/**
 * Structural guard for error-shaped values that aren't `Error` instances — the parsed JSON body an
 * `@gonfalon/openapi` operation returns, for example. Empty messages don't count: a caller that
 * matches on this is about to show the message to someone.
 */
export function isErrorWithMessage(error: unknown): error is { message: string } {
  return (
    error !== undefined &&
    error !== null &&
    typeof error === 'object' &&
    'message' in error &&
    typeof error.message === 'string' &&
    error.message !== ''
  );
}
